export const ENV_AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN as string;
export const ENV_AUTH0_CLIENT_ID = import.meta.env
  .VITE_AUTH0_CLIENT_ID as string;
export const ENV_AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE as string;
export const ENV_AUTH0_CACHE_LOCATION = (import.meta.env
  .VITE_AUTH0_CACHE_LOCATION ?? "localstorage") as "localstorage" | "memory";
export const ENV_APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL as string;
export const ENV_GOOGLE_MAPS_API_KEY = import.meta.env
  .VITE_GOOGLE_MAPS_API_KEY as string;
export const ENV_API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  "http://localhost:3000";
export const ENV_ENABLE_DASHBOARD =
  import.meta.env.VITE_ENABLE_DASHBOARD !== "false";

export const ENABLE_FEATURE_USER_MANAGEMENT =
  import.meta.env.VITE_ENABLE_FEATURE_USER_MANAGEMENT === "true";
